import { ShoppingListItem } from '../types';

export const parseShoppingListCookie = (cookieValue: string | null | undefined): ShoppingListItem[] => {
  if (!cookieValue) return [];

  return decodeURIComponent(cookieValue)
    .split(';')
    .reduce<ShoppingListItem[]>((acc, item) => {
      const trimmedItem = item.trim();
      if (!trimmedItem) return acc;

      const [id, qty] = trimmedItem.split(':');
      const quantity = Number.parseInt(qty, 10);

      if (id && !Number.isNaN(quantity)) {
        acc.push({ id: id, quantity });
      }

      return acc;
    }, []);
};
